import {TouchableOpacity, View} from 'react-native';

import useWindowDimensionsSafe from 'src/Modules/Native/useWindowDimensionsSafe';

import {BodyText} from 'src/Modules/CommonView/Text';
import {ClassicIconButton} from 'src/Modules/CommonView/Buttons';
import {ProgressBar} from '../ScavengerHunt_v2/Classic/Header';
import React from 'react';
import {Share} from 'react-native';
import {apiFavoriteLocation} from '../Utils/apiCalls';
import {useSelector} from 'react-redux';
import {useUserId} from 'src/Hooks/reduxHooks';
const LocalSiteModalHeader = ({
  completionPercent = 0,
  location = {},
  completedChallengesCount = 0,
  challengeCount = 1,

  startChallenges,
}) => {
  const {width} = useWindowDimensionsSafe();
  const {title, photo, id} = location;

  const userId = useUserId();
  const localDataRefetch = global.localDataRefetch;
  const selectedLocalLocationId = useSelector(
    (state) => state.local.selectedLocalLocationId,
  );
  const localFavorites = useSelector((state) => state.local.localFavorites);

  const isFavorited = localFavorites?.includes?.(selectedLocalLocationId + '');

  return (
    <View
      testID="LocalSiteModalHeader"
      style={{
        borderTopWidth: 1,
        borderTopColor: global?.color?.white1,
        backgroundColor: global?.color?.white,
        borderBottomLeftRadius: 20,
        borderBottomRightRadius: 20,
        position: 'relative',
        width,
      }}>
      <View style={{paddingTop: 5, paddingBottom: 10}}>
        <BodyText
          text={title + (__DEV__ ? ` - ${id}` : '')}
          textStyle={{
            fontWeight: '700',
            textAlign: 'center',
            fontSize: 18,
            lineHeight: 20,
          }}
        />
      </View>
      <View style={{flexDirection: 'row', height: 120}}>
        <View
          style={{
            flex: 1,
            justifyContent: 'center',
            alignItems: 'center',
            marginLeft: 10,
          }}>
          <ClassicIconButton
            handlePress={() =>
              Share.share({
                title: `Let's Roam Local Site`,
                message: `Check out ${title} in Let's Roam Local and do fun challenges!`,
                url: 'https://letsroam.page.link/local',
              })
            }
            text={`Share`}
            icon="share"
            color="teal"
          />
        </View>
        <View
          style={{
            flex: 1,
            minWidth: 120,
            maxWidth: 160,
            justifyContent: 'center',
            alignItems: 'center',
          }}>
          <ProgressBar
            percentage={completionPercent * 100}
            centerImageUrl={photo}
            handlePress={() => startChallenges()}
          />
        </View>
        <View
          style={{
            flex: 1,
            justifyContent: 'center',
            alignItems: 'center',
            marginRight: 10,
          }}>
          <ClassicIconButton
            handlePress={async () => {
              apiFavoriteLocation({
                user_id: userId,
                product_id: selectedLocalLocationId,
                product_type: 'local_site',
                favorited: !isFavorited,
              });
              localDataRefetch();
              // Alert.alert('This Location')
            }}
            text={isFavorited ? 'Favorited' : 'Favorite'}
            icon="heart"
            color={isFavorited ? 'red' : 'blue'}
          />
        </View>
      </View>
      <View>
        <TouchableOpacity onPress={startChallenges}>
          <BodyText
            text={`${completedChallengesCount} / ${challengeCount}  Challenges Complete`}
            textStyle={{
              color: global?.color?.gray2,
              marginTop: 15,
              marginBottom: 15,
              textAlign: 'center',
            }}
          />
        </TouchableOpacity>
      </View>
    </View>
  );
};

export default LocalSiteModalHeader;
